import { FC, ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import ConfigContext from 'src/context/config';
import useNonNullContext from 'src/hooks/useNonNullContext';

interface Props {
  title: string;
  subtitle?: string;
  designer: string;
  action?: ReactNode;
}

const MealDetailsHeader: FC<Props> = ({
  title,
  subtitle,
  designer,
  action,
}) => {
  const config = useNonNullContext(ConfigContext);
  const {
    mealDetailProfile: { showSupplier },
  } = config;

  return (
    <Box
      sx={{
        padding: '1rem',
        borderBottom: '1px solid #DAD4BC',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '1rem',
      }}
    >
      <Box>
        <Typography variant={'h6'}>
          {title} {subtitle}
        </Typography>
        {showSupplier && (
          <Typography variant={'body1'}>by {designer}</Typography>
        )}
      </Box>
      {action ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            flexShrink: 0,
          }}
        >
          {action}
        </Box>
      ) : null}
    </Box>
  );
};

export default MealDetailsHeader;
